import { atom } from 'recoil';

const openCondAddonModalState = atom({
  key: 'openCondAddonModalState',
  default: false,
});

export { openCondAddonModalState };
